import { ScheduleShift, shiftsToWorkHours } from '@bemlo/schedule'
import { Maybe } from '@bemlo/utils'

import { Color, theme } from '../../../../constants'
import { Avatar, Div, Flex, Link, Text } from '../../../../elements'
import { useTranslations } from '../../../../translate'

type ResourceTitleProps = {
  title: string | null
  shifts: ScheduleShift[] | null
  avatar?: { url: Maybe<string> } | null
  url?: Maybe<string>
  bold?: boolean
}

export const ResourceTitle = (props: ResourceTitleProps) => {
  const t = useTranslations()
  const time = shiftsToWorkHours(props.shifts ?? [])
  const nameTitle = props.url ? (
    <Link
      to={props.url}
      styles={{
        color: Color.BLUE,
        fontWeight: theme.font.weight.bold,
        fontSize: theme.font.size[6.5],
      }}
    >
      {props.title}
    </Link>
  ) : (
    <Text
      fontSize={theme.font.size[6.5]}
      color={props.bold ? Color.BLUE : Color.DARKER_GREY}
      fontWeight={props.bold ? theme.font.weight.bold : theme.font.weight.book}
    >
      {props.title}
    </Text>
  )

  return (
    <Div styles={{ height: '100%' }}>
      <Flex
        gap={2}
        items="center"
        styles={{
          px: 2,
          py: 1,
          height: '100%',
          justifyContent: props.title === null ? 'center' : undefined,
        }}
      >
        {props.avatar && (
          <Avatar
            type={props.avatar.url ? 'image' : 'initials'}
            name={props.title}
            image={props.avatar.url}
            size="sm"
          />
        )}
        <Flex col>
          {props.title !== null && nameTitle}
          {props.shifts && (
            <Text
              fontSize={theme.font.size['6.5']}
              color={Color.DARKEST_MEDIUM_GREY}
              fontWeight={theme.font.weight.book}
            >
              {t.$date.formatDuration({ hours: time })} / {props.shifts.length}{' '}
              {props.shifts.length === 1
                ? t.shifts.shift_one().toLocaleLowerCase()
                : t.shifts.shift_other().toLocaleLowerCase()}
            </Text>
          )}
        </Flex>
      </Flex>
    </Div>
  )
}
